import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import HeaderSectionMobilePage from '../../../../components/Mobile/headerSection';
import { useFormContext } from 'react-hook-form';
import InputSelectMobile from '../../../../components/Input/Mobile/Select';
import { FaFile } from 'react-icons/fa';
import SpecialConditionList from './specialCondition/card';
import { ISpecialCondition } from '../../../../services/hooks/CandidateArea/useGetDataToRegistration';

interface IOwnProps {
  specialCondition: ISpecialCondition[];
}

const RegistrationSpecialConditionMobilePage: React.FC<IOwnProps> = ({ specialCondition }) => {
  const { watch, formState } = useFormContext();

  const accent = '#222';

  const listSpecialCondition = [
    { id: 'yes', name: 'Sim' },
    { id: 'no', name: 'Não' },
  ];

  return (
    <Stack>
      <HeaderSectionMobilePage>Atendimento especial</HeaderSectionMobilePage>
      <FormControl mt={1} isInvalid={!!formState.errors.has_special_condition}>
        <FormLabel ml={1} fontSize="sm" fontWeight="normal">
          Você deseja informar algum atendimento especial?
        </FormLabel>
        <InputSelectMobile
          name="has_special_condition"
          placeholderLabel="Atendimento especial"
          iconLeft={<FaFile size={12} color={accent} />}
          isRequired
          listItens={listSpecialCondition}
        />
      </FormControl>
      {watch('has_special_condition') === 'yes' && (
        <Stack>
          <SpecialConditionList conditions={specialCondition} />
        </Stack>
      )}
    </Stack>
  );
};

export default RegistrationSpecialConditionMobilePage;
